var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],staticClass:"auth-input",style:(_vm.style),attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.content)},on:{"input":[function($event){if($event.target.composing)return;_vm.content=$event.target.value},_vm.sendOut]}})
}
var staticRenderFns = []

export { render, staticRenderFns }